import { createSlice } from '@reduxjs/toolkit';

export const subAccountTransferHistoryParams = createSlice({
  name: 'subAccountTransferHistoryParams',
  initialState: {
    page: 1,
    limit: 25,
  },
  reducers: {
    setHistoryParams: (state, action) => ({ ...state, ...action.payload }),
  },
});

export const { setHistoryParams } = subAccountTransferHistoryParams.actions;

export const subAccountTransferHistoryParamsSelector = (state) =>
  state[subAccountTransferHistoryParams.name];
